export const useSidebarControl = () => {
	const sidebarOpenPreference = useLocalStorage('sidebar-open-preference', true);
	const sidebarOpen = ref(sidebarOpenPreference.value);

	return {
		sidebarOpenPreference,
		sidebarOpen,
	};
};
